<template>
  <div class="flex items-center justify-center h-64 bg-white border border-gray-200 rounded-lg shadow-sm">
    <div class="text-center px-4">
      <div class="mx-auto mb-3 w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center">
        <b-icon pack="fas" icon="info-circle" type="is-dark" class="text-2xl" />
      </div>
      <h3 class="text-lg font-semibold text-gray-800">Sin datos disponibles</h3>
      <p class="text-sm text-gray-500 mt-1">Aún no hay información para mostrar en este panel.</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EmptyPanel',
    props: {
      showHeader: {
        type: Boolean,
        default: true
      }
    }
  };
</script>